import axios from "axios";
import React, { useState } from "react";
import "react-dropdown/style.css";
import { getFiftyOneRequestContext } from "../../../utils/fiftyone";
import { buttonText } from "../../../utils/buttonText";

function DeleteSamplesPage(props) {
  let { item, loadDatasetList } = props;
  const sampleCount = item.samples?.length || 0;

  let [deleteLoading, setDeleteLoading] = useState(false);

  const deleteSelectedSamples = async () => {
    if (sampleCount === 0) {
      window.alert(`There is no sample in dataset '${item.name}'`);
      return;
    }
    setDeleteLoading(true);
    try {
      await axios.delete("/datasets/delete/selected_samples", {
        data: {
          dataset_name: item.name,
          ...getFiftyOneRequestContext(),
        },
      });
      loadDatasetList();
      window.alert(
        `Delete selected samples on dataset '${item.name}' success`
      );
    } catch (error) {
      const errorMsg =
        error.response?.data?.error || error.response?.data || error.message;
      window.alert(errorMsg);
    } finally {
      setDeleteLoading(false);
    }
  };

  return (
    <div className="delete-samples-page">
      <div className="info-section">
        <p className="card-text">
          Media type: {item.media_type || "unknown"}
        </p>
        <p className="card-text">Samples: {sampleCount.toLocaleString()}</p>
      </div>
      <button
        type="button"
        className="org-btn org-btn-danger"
        onClick={deleteSelectedSamples}
        disabled={deleteLoading}
      >
        {buttonText(deleteLoading ? "Loading..." : "Delete Selected")}
      </button>
    </div>
  );
}

export default DeleteSamplesPage;
